module.exports = __webpack_public_path__ + "static/media/main_small_4.cdfa2856.png";